// Parâmetros de link de e-mail que não podem ficar na barra de endereço, no
// histórico do navegador nem ser repassados no Referer.
const SENSITIVE_PARAMS = ['token', 'password', 'pass', 'id', 'time'];

// Remove os parâmetros sensíveis da URL atual sem recarregar a página.
// Os demais (ex.: redirect, sourceId, cnpj) continuam.
export function stripSensitiveParams(params = SENSITIVE_PARAMS) {
  const url = new URL(window.location.href);
  let changed = false;

  params.forEach((name) => {
    if (url.searchParams.has(name)) {
      url.searchParams.delete(name);
      changed = true;
    }
  });

  if (changed) {
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  }
}
